/**
 * @file groups.component.tsx
 * @description Компонент фильтра по группам для каталога Task Manager приложения. Предоставляет боковой панель с иерархическим списком групп через Tree компонент, чекбокс для включения/отключения фильтрации и систему выбора множественных групп для фильтрации содержимого каталога. Использует forwardRef для предоставления императивного API получения выбранных элементов. Используется для фильтрации каталогов по группам с множественным выбором и возможностью редактирования.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-09-19
 * @dependencies ['@components/ui/base/dhx-checkbox', '@components/ui/indicators/loader', '@components/ui/data/tree', 'react']
 * @related-files ['src/features/catalog/catalog.component.tsx', 'src/components/ui/data/tree/tree.component.tsx', 'src/components/ui/base/dhx-checkbox']
 * TODO: доделать компонент (указание группы при активном чекбоксе и изменение состава групп)
 */

import { DhxCheckbox } from '@components/ui/base/dhx-checkbox';
import { Loader } from '@components/ui/indicators/loader';
import { Tree } from '@components/ui/data/tree';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import type {
    IGroupFilterProps,
    IGroupFilterHandlers,
    TOptionalCheckedItems
} from '@src/types/tree-components';

//TODO: доделать компонент (указание группы при активном чекбоксе и изменение состава групп)

export const GroupFilter = forwardRef<IGroupFilterHandlers, IGroupFilterProps>(
    ({ groups, onCheckItem, onEditButtonClick }: IGroupFilterProps, ref) => {
        const [isUseFilter, setIsUseFilter] = useState(false);
        const [checkedItems, setCheckedItems] = useState<TOptionalCheckedItems>([]);
        const checkedItemsRef = useRef(checkedItems);

        useEffect(() => {
            checkedItemsRef.current = checkedItems;
        }, [checkedItems]);

        useImperativeHandle(
            ref,
            (): IGroupFilterHandlers => ({
                getCheckedItems: () => {
                    return isUseFilter ? checkedItemsRef.current : null;
                }
            }),
            [isUseFilter]
        );

        return (
            <div className="catalog__groups w-[34.0318vmin] mr-[3.1756vmin] border-r overflow-y-auto">
                <DhxCheckbox
                    className="mb-[1.0585vmin]"
                    checked={isUseFilter}
                    onChange={(checked: boolean) => {
                        setIsUseFilter(checked);
                        onCheckItem && onCheckItem(null);
                    }}
                    title="Фильтр по группе"
                />

                <div className="catalog__groups-tree">
                    {groups?.length > 0 ? (
                        <Tree
                            disabled={!isUseFilter}
                            data={groups}
                            onCheckItems={(newCheckedItems: string[]) => {
                                setCheckedItems(newCheckedItems);
                                onCheckItem && onCheckItem(newCheckedItems);
                            }}
                            checkbox={true}
                            onEditButtonClick={onEditButtonClick}
                            className="pr-[1.5878vmin]"
                        />
                    ) : (
                        <Loader className="mt-default" />
                    )}
                </div>
            </div>
        );
    }
);
